$(window).on('load', function () {
  // Remove the spinner
  $('.boutiques_spinner_v1_target').fadeOut();

  // Handle linking to specific sections
  function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);

    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  // Handle links...?mod[num]=boutique_mod[num]
  function scrollToLinkMod(linkNo) {
    if (getParameterByName('mod' + linkNo) === 'boutique_mod' + linkNo) {
      $('html, body')
        .delay(500)
        .animate(
          {
            scrollTop: $('#np_mod' + linkNo).offset().top - 100
          },
          1500,
          'easeInOutQuad'
        );
    }
  }

  for (i = 2; i <= 6; i++) {
    scrollToLinkMod(i);
  }

  // Hide play button if no video code is entered
  if (!$('#np_mod1_video').data('yt3-src')) {
    $('#np_mod1 .night_proteins_video_hero_play, #np_mod1 .night_proteins_video_hero_cta').hide();
  }

  if (!$('#np_mod2_video').data('yt-src')) {
    $('#np_mod2 .np_video_tvc_play, #np_mod2 .np_video_tvc_cta').hide();
  }

  // Handle the hero animations
  $('.np_hero_1').css(
    {
      opacity: '0',
      top: '14.1%'
    },
    420
  );
  $('.np_hero_2').css(
    {
      opacity: '0',
      top: '37.2%'
    },
    420
  );
  $('.np_hero_3').css(
    {
      opacity: '0',
      top: '47.3%'
    },
    420
  );
  $('.np_hero_4').css(
    {
      opacity: '0',
      top: '57.5%'
    },
    420
  );
  $('.np_hero_5').css(
    {
      opacity: '0',
      top: '68.9%'
    },
    420
  );
  $('.np_hero_6').css(
    {
      opacity: '0',
      top: '87%'
    },
    420
  );

  $('.np_hero_1').delay(250).animate(
    {
      opacity: 1,
      top: '4.1%'
    },
    420
  );
  $('.np_hero_2').delay(450).animate(
    {
      opacity: 1,
      top: '27.2%'
    },
    420
  );
  $('.np_hero_3').delay(650).animate(
    {
      opacity: 1,
      top: '37.3%'
    },
    420
  );
  $('.np_hero_4').delay(850).animate(
    {
      opacity: 1,
      top: '47.5%'
    },
    420
  );
  $('.np_hero_5').delay(850).animate(
    {
      opacity: 1,
      top: '58.9%'
    },
    420
  );
  $('.np_hero_6').delay(850).animate(
    {
      opacity: 1,
      top: '77%'
    },
    420
  );
});

var mppContext = $('#night_routine_mpp_next').parent().next('.mpp');

(function ($) {
  Drupal.behaviors.np_formatter_mob = {
    attach: function (context, settings) {
      $('.np_formatter_mob', context).once('np_formatter_mob', function () {
        /** SETUP **/
        // Apply classes
        function makeBoutiqueChecks() {
          // Check for Windows.
          if (navigator.platform == 'Win32') {
            $('body').addClass('isWin');
          }

          // Check for Safari.
          if (
            navigator.userAgent.indexOf('Safari') != -1 &&
            navigator.userAgent.indexOf('Chrome') == -1
          ) {
            $('body').addClass('isSafari');
          }

          // Check for Firefox.
          var isFF = false;

          if (navigator.userAgent.search('Firefox') >= 0) {
            $('body').addClass('isFF');
            isFF = true;
          }

          // Check for IE.
          var isIE = false;

          if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
            isIE = true;
          }
          if (isIE) {
            if ($('body').hasClass('isTouch')) {
              $('body').removeClass('isTouch');
            }
          }

          // Check for mobile device
          var isMobile = false;

          if (
            /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
          ) {
            isMobile = true;
            $('body').addClass('isMobile');
          }

          // Check for iPad.
          var isTouch = false;

          if (navigator.userAgent.match(/iPad/i) != null) {
            isTouch = true;
            $('body').addClass('isTouch');
          }
        }
        makeBoutiqueChecks();

        /** ** VIDEO FUNCTIONALITY ****/
        // Orientation checks for player styling.
        var iosCheck = false;

        if (navigator.userAgent.match(/iPhone|iPod/i) != null) {
          iosCheck = true;
          $('body').addClass('isIOS');
        }

        function detectInitialOrientation() {
          if (iosCheck === true) {
            if ($(window).height() < $(window).width()) {
              $('#np_mod2_video, #np_mod1_video').addClass('isLandscape'); // , #r4_mod6_video
            } else if ($(window).height() < $(window).width()) {
              if ($('#np_mod2_video, #np_mod1_video').hasClass('isLandscape')) {
                // , #r4_mod6_video
                $('#np_mod2_video, #np_mod1_video').removeClass('isLandscape'); // , #r4_mod6_video
              }
            }
          } else if (iosCheck === false) {
            if ($(window).height() < $(window).width()) {
              $('#np_mod2_video , #np_mod1_video').addClass('isLandscape');
            } else if ($(window).height() > $(window).width()) {
              if ($('#np_mod2_video , #np_mod1_video').hasClass('isLandscape')) {
                $('#np_mod2_video , #np_mod1_video').removeClass('isLandscape');
              }
            }
          }
        }
        detectInitialOrientation();

        function detectOrientationChange() {
          if (iosCheck === true) {
            if (window.innerHeight < window.innerWidth) {
              $('#np_mod2_video , #np_mod1_video').addClass('isLandscape');
            } else if (window.innerHeight > window.innerWidth) {
              if ($('#np_mod2_video , #np_mod1_video').hasClass('isLandscape')) {
                $('#np_mod2_video , #np_mod1_video').removeClass('isLandscape');
              }
            }
          } else if (iosCheck === false) {
            if (window.innerHeight > window.innerWidth) {
              $('#np_mod2_video , #np_mod1_video').addClass('isLandscape');
            } else if (window.innerHeight < window.innerWidth) {
              if ($('#np_mod2_video , #np_mod1_video').hasClass('isLandscape')) {
                $('#np_mod2_video , #np_mod1_video').removeClass('isLandscape');
              }
            }
          }
        }
        $(window).on('orientationchange', function (event) {
          detectOrientationChange();
        });

        /* MODULE 7 PARALLAX - 360 VIDEO */
        // Init the controller.
        var controller = new ScrollMagic.Controller();
        // Set the parallax duration
        var windowHeight = $(window).height();

        parallaxDuration = windowHeight / 1;

        /** ** VIDEO FUNCTIONALITY ****/
        // Players.
        var player1;
        var player2;
        // Video Sources.
        var src1 = $('#np_mod2_video').data('yt-src'); // 'qCWsCSBL6G0';
        var src2 = $('#np_mod1_video').data('yt3-src');
        // Initialise YouTube API.
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];

        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // Execute as soon as the player API is ready.
        onYouTubeIframeAPIReady = function () {
          player1 = new YT.Player('np_mod2_video_container', {
            videoId: src1,
            playerVars: {
              enablejsapi: 1,
              autohide: 1,
              autoplay: 0,
              cc_load_policy: 0,
              controls: 0,
              disablekb: 0,
              end: 0,
              wmode: 'transparent',
              fs: 1,
              loop: 0,
              html5: 1,
              playsinline: 1
            },
            events: {
              onReady: playerOneReady
            }
          });
          player2 = new YT.Player('np_mod1_video_container', {
            videoId: src2,
            playerVars: {
              enablejsapi: 1,
              autohide: 1,
              autoplay: 0,
              cc_load_policy: 0,
              controls: 0,
              disablekb: 0,
              end: 0,
              wmode: 'transparent',
              fs: 1,
              loop: 0,
              html5: 1,
              playsinline: 1
            },
            events: {
              onReady: playerTwoReady
            }
          });
        };

        // When the Players are ready.
        var duration1, videoInterval1, duration2, videoInterval2;
        var close1 = $('#np_mod2 .boutique__video_close_x');
        var close2 = $('#np_mod1 .boutique__video_close_x');
        var playTrigger1 = $('#np_mod2 .np_video_tvc_play, #np_mod2 .np_video_tvc_cta'); // ,
        var playTrigger2 = $(
          '#np_mod1 .night_proteins_video_hero_play, #np_mod1 .night_proteins_video_hero_cta'
        );
        var playPauseBtn;

        function playerOneReady() {
          duration1 = player1.getDuration();
          videoInterval1 = $('#np_mod2_video .boutique__video_inner_scrubber');
        }

        function playerTwoReady() {
          duration2 = player2.getDuration();
          videoInterval2 = $('#np_mod1_video .boutique__video_inner_scrubber');
        }

        // Play the videos.
        function playEach(theNum, eachPlayerNum, eachInterval, eachDuration, eachClose, eachEnd) {
          $('#np_mod' + theNum + '_video .boutique__video_close_x').show();
          $('#np_mod' + theNum + '_video.boutique__video_top_video').fadeIn();
          $('#np_mod' + theNum + '_video .boutique__video_play_btn').addClass('active');
          $('#np_mod' + theNum + '_video_container').show();
          scrubberAndPlay(eachPlayerNum, eachInterval, eachDuration, eachClose, eachEnd);
        }

        playTrigger1.click(function () {
          $('.np_formatter_mob').addClass('vid_active');
          playEach(2, player1, videoInterval1, duration1, close1, 1);
        });

        playTrigger2.click(function () {
          $('.np_formatter_mob').addClass('vid_active');
          playEach(1, player2, videoInterval2, duration2, close2, 1);
        });

        // Handle the scrubber.
        function scrubberAndPlay(playerNum, vidInterval, duration, close, closeTime) {
          player1.pauseVideo();
          player2.pauseVideo();
          playerNum.seekTo(0, true);
          playerNum.playVideo();

          vidInterval = setInterval(function () {
            var currentTime = playerNum.getCurrentTime(),
              multipliedTime = (currentTime / duration) * 100 + 3;

            if (currentTime >= duration - closeTime) {
              close.click();

              return;
            }
          }, 30);
        }

        // Close the videos.
        function closePlayer(whichPlayer, playerNum, whichInterval) {
          whichPlayer.pauseVideo();
          whichPlayer.stopVideo();
          $('#np_mod' + playerNum + '_video_container').hide();
          $('#np_mod' + playerNum + '_video .boutique__video_close_x').hide();
          $('#np_mod' + playerNum + '_video .boutique__video_play_btn').removeClass('active');
          clearInterval(whichInterval);
          $('#np_mod' + playerNum + '_video.boutique__video_top_video ').fadeOut();
        }

        close1.click(function () {
          $('.np_formatter_mob').removeClass('vid_active');
          closePlayer(player1, 2, videoInterval1);
        });
        close2.click(function () {
          $('.np_formatter_mob').removeClass('vid_active');
          closePlayer(player2, 1, videoInterval2);
        });
      });
    }
  };
})(jQuery);
